<template>
    <div id="app" :class="[$store.state.productType, `site_${$store.state.siteInfos.RefClient}`]">
        <MainNav v-if="$route.name !== 'home'"></MainNav>
        <router-view/>

        <Loader v-if="isLoading"></Loader>
        <div v-html="outPutStyle"></div>
      <footer class="app"  v-if="$route.name !== 'home'">
        <p>Réalisation :<a href="https://industrie.wiboo.fr/configurateur-de-produits-sur-mesure/">Wiboo, spécialiste en configurateurs </a></p>
      </footer>
        <div class="modal fade" id="basicModal" tabindex="-1" role="dialog"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img class="modal-img img-responsive" src="">
                        <div class="extra-popup"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">J'ai compris</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import MainNav from "./components/MainNav";
    import Loader from "./components/Loader";

    export default {
        components: {Loader, MainNav},
        component: {
            MainNav
        },
        computed: {
            isLoading() {
                return this.$store.state.isLoaderShowing
            },
            analyticsScript() {
                return this.$store.state.siteInfos.analyticsScript
            },
            outPutStyle() {
                let extra = "";
                if (!this.$store.state.siteInfos.reduction_active) {
                    extra = ".extra.quantite{display:none}"
                } else {
                    extra = `.extra.quantite h2{background:${this.siteColor}!important}`
                }

                return `
<style>

/*INLINE HTML*/
    ${extra}



    .button-recap {

        border: 3px solid ${this.siteColor};

    }
    .button-recap i {
        color: ${this.siteColor};
    }
    .user-history-buttons-container.is-recap .order-now{
            background: ${this.siteColor}
    }
    .delais-popup-trigger{
        background: ${this.siteColor}
    }

    .choice::before {
        background: ${this.siteColor}
    }

    .back-btn,
    .back-btn:hover {
        background: ${this.siteColor}
    }

    .slider:before {
        background-color: ${this.siteColor}
    }

    .change-btn button,
    .change-btn button:focus {
        background-color: ${this.siteColor}
    }

    .constructor-header a.selected {
        background: ${this.siteColor}
    }

    .constructor-header a.selected::after {
        background: ${this.siteColor}
    }

    .popup-valid .button-list .btn.main {
        background: ${this.siteColor}
    }

    .popup-valid {
        border: 15px solid ${this.siteColor}
    }

    .controls i:hover {
        color: ${this.siteColor}
    }

    .card .selected img, .card .selectedAuto {
        border: solid 2px ${this.siteColor};
    }

    .mobile-nav-viewer .rounded-icon {
        background-color: ${this.siteColor};
    }

    .popup-valid.confirm-popup .modal-footer .main {
        background: ${this.siteColor};
    }

    .qty-changer i:hover,
    .qty-changer i:focus {
        color: ${this.siteColor}
    }

    .bandeau {
        background: ${this.siteColor};
    }

    a.constructorNavLinks.selected {
        background: ${this.siteColor} !important;
    }

    a.constructorNavLinks.selected::after {
        background: ${this.siteColor} !important;
    }

    .home-link,
    .home-link:hover,
    .home-link:focus {
        color: ${this.siteColor};
    }

    .home .footer, .change-btn {
        /*border-top: 2px solid ${this.siteColor};*/
    }

    .choice-link-button:before {
        background: ${this.siteColor};
    }

    .router-link {
        border: solid ${this.siteColor} 1px;
    }

    .TextRadioChoice .checkbox-choice.selected {
        border: 1px solid ${this.siteColor};
        background-color:  ${this.siteColor};
        color: #ffffff;
    }
    .content h2 {
        background: ${this.siteColor};
    }
    .change-btn-userhistory .next-button{
        background: ${this.siteColor}!important;
    }

    .site-colors {
        color: ${this.siteColor};
    }

    .price-container {
        background-color: ${this.siteColor};
    }

    .yellow-one {
        color: ${this.siteColor} !important;
        border: 2px solid ${this.siteColor};
    }

    .avecPose {
        background: ${this.siteColor};
    }

    /*.checkbox-choice.selected {
        border: solid 2px ${this.siteColor};
    }*/

    .card-header.answered {
        background-color: ${this.siteColor};
    }

    @media screen and (min-width: 0 \\\\\\\\0) and (min-resolution: +72dpi) {
        .choice:before {
            background: none;
        }

        .choice {
            background: ${this.siteColor};
        }
    }

    @media screen and (max-width: 1023px) {
    }
        /*END INLINE HTML*/
</style>`
            },
            siteColor() {
                return this.$store.state.siteInfos.Couleur
            }
        },
        mounted: function () {
            if (sessionStorage.getItem("is_reloaded")) {
                this.$router.push('/').catch();
                sessionStorage.setItem("is_reloaded", false)
            } else {
                sessionStorage.setItem("is_reloaded", true)
            }
        },
        created: function () {
            this.$store.dispatch('loadSiteInfos')
        }
    }
</script>
<style>

    /*Removes browser styles*/
    body {
        margin: 0;
        padding: 0;
    }
    footer.app{
      position: absolute;
      bottom: 10px;
      right: 20px;
      z-index: 100000;
      display: inline-flex;
    }
    footer p{
      margin:0;
      color:#bebebe;
    }
    footer a{
      color:#bebebe;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
      position:relative;
        /* height:100vh; */
    }

    @media screen and (max-width: 500px) {
        #app {
            height: 110vh;
        }
    }

    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    /*BLOCK TABLET FORMAT TO LANDSCAPE*/
    /*@media screen and (min-width: 600px) and (max-width: 768px) and (orientation: portrait) {
        html {
            transform: rotate(-90deg);
            transform-origin: left top;
            width: 100vh;
            overflow-x: hidden;
            position: absolute;
            top: 100%;
            left: 0;
        }
    }*/

    @media screen and (max-width: 1200px) {
        body {
            font-size: 0.7rem;
        }
    }

    @media screen and (max-width: 1024px) {
        .modal-content {
            max-height: 95vh;
        }
        .modal-header {
            max-height: 10vh;
        }
        .modal-footer {
            max-height: 10vh;
        }
        .modal-body {
            max-height: 75vh;
        }
        .modal-body img {
            max-height: 40vh;
            margin-bottom: 1em;
        }
        .modal-body .extra-popup{
            max-height: 35vh;
        }
    }

    @media screen and (max-width: 575px) {
        h2 {
            font-size: 1.5rem;
        }
        html .content {
            padding: 20px 0 20px 0;
        }
        .home .content h2 {
            padding: 5px;
        }
    }

</style>
